export default "__VITE_ASSET__UBOJA2Pe__"